import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { GetStudentAnswers } from "../../api/Quiz/GetStudentAnswers";

const PastAttempts = ({ quizId }: { quizId: string }) => {
  const { data, isLoading } = useQuery({
    queryFn: () => GetStudentAnswers(quizId),
    queryKey: ["pastAttempts", quizId],
    staleTime: 0,
    // Fresh on mount, never in the background; see QuizAnswers.tsx.
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const attempts = [...(data?.data?.studentAnswers ?? [])].sort(
    (a, b) => a.num_tries - b.num_tries
  );

  if (isLoading) return null;
  if (data?.error) return null;
  if (attempts.length === 0) return null;

  return (
    <div className="mt-8">
      <h2 className="font-bold text-lg mb-4">Past Attempts</h2>
      <div className="space-y-3">
        {attempts.map((attempt) => (
          <div
            key={`${quizId}-${attempt.num_tries}`}
            className="flex items-center justify-between border border-black/10 rounded-lg px-4 py-3 bg-white shadow-sm"
          >
            <div className="flex gap-6 font-medium text-sm text-[#333]">
              <span>Trial #{attempt.num_tries}</span>
              <span className="text-primary">{attempt.score}%</span>
              <span
                className={
                  attempt.status === "passed"
                    ? "text-green-500"
                    : "text-red-500"
                }
              >
                {attempt.status}
              </span>
            </div>
            <Link
              to={`/quiz-answers/${quizId}/${attempt.num_tries}`}
              target="_blank"
              className="text-sm text-primary underline hover:opacity-75"
            >
              View
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PastAttempts;
